module.exports = __webpack_public_path__ + "static/media/pos.b0a98c48.png";